import DateOpenQuestion from 'models/common/form/question/open/DateOpenQuestion';

export default class DateOpenQuestionService {
	toModel(question) {
		return new DateOpenQuestion(question);
	}
}
